import {
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Switch,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Icons from "../../../../../Config/Images";
import {
  createGenericDataAPI,
  getGlobalGenericNameAPI,
} from "../../../../../Store/Action/globalAction";
import {
  getLoggedInUserDetailsAPI,
  logOutUserAPI,
} from "../../../../../Store/Action/UserAction";
import { logout } from "../../../../../Store/Slice/authSlice";
import { logoutUser } from "../../../../../Store/Slice/UserSlice";
import LogoutModal from "../CustomModals/LogoutModal";
// import styles from "./styles";
import "./Settings.css";
import persistStore from "redux-persist/es/persistStore";
import { store } from "../../../../../Store";
import { resetOnboardingFlag } from "../../../../../Store/Slice/onboardingSlice";

const Spinner = () => (
  <div className="spinner">
    <div className="double-bounce1"></div>
    <div className="double-bounce2"></div>
  </div>
);
const SettingComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [wastageEnabled, setWastageEnabled] = useState(false);
  const [genericTypeId, setGenericTypeId] = useState();
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(true); // Loading state to show while fetching

  const handleCloseModal = () => {
    setIsLogoutOpen(false);
  };
  const loggedInUserCall = () => {
    dispatch(getLoggedInUserDetailsAPI({}, (result) => {}));
  };
  const handleLogOut = () => {
    dispatch(
      logOutUserAPI({}, (result) => {
        if (result?.status) {
          dispatch(logout());
          dispatch(logoutUser());
          dispatch(resetOnboardingFlag());
          persistStore(store).purge(); // Clears `persist:root` from local storage
          localStorage.removeItem("persist:root"); // Force remove persisted state
          localStorage.removeItem("userId"); // Force remove user
          localStorage.removeItem("startTime"); // Force remove start timer
          localStorage.removeItem("flagOnboarded"); // Force remove flag onboarded flag
          localStorage.removeItem("isRefillingOnboardingFormIsNowInReviewed");
          localStorage.removeItem("cameFromHomeClick");
          toast.success(result?.data?.message);
          loggedInUserCall();
          setTimeout(() => {
            navigate("/home", { replace: true }); // Ensure navigation happens after API call
          }, 500); // Added delay to ensure function executes
        }
        setIsLogoutOpen(false);
      })
    );
  };

  useEffect(() => {
    dispatch(
      getGlobalGenericNameAPI({}, (result) => {
        if (result && Array?.isArray(result)) {
          const userShopNameInfo = result?.find(
            (item) => item?.generic_data_type_name === "wastage"
          );
          setGenericTypeId(userShopNameInfo?.generic_data_type_id || null);
        }
      })
    );
  }, [dispatch]);

  const handleWastageToggle = () => {
    const requestData = {
      user_generic_type_id: genericTypeId || 1,
    };
    try {
      dispatch(
        createGenericDataAPI(requestData, (isSuccess, result) => {
          if (isSuccess?.status === true) {
            // toast.success(result?.data?.message);
            // Update the UI immediately to reflect the change
            setWastageEnabled((prev) => !prev); // Toggle the wastageEnabled state
          } else {
            toast.error(result?.error?.message);
          }
        })
      );
    } catch (error) {
      toast.error("somethingWentWrongError");
    }
  };

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setWastageEnabled(
          result?.data?.[0]?.user_generic_data_value[0]
            ?.user_generic_data_boolean_value
        );
        setIsLoading(false); // Set loading to false after data is fetched
      })
    );
  }, []);

  return (
    // <div
    //   style={{
    //     position: "absolute",
    //     // width: "200px",
    //     // padding: "10px",
    //     zIndex: 1000,
    //     left: "88%",
    //     top: 62,
    //     left: -110,
    //     backgroundColor: "white",
    //     border: "1px solid #D3D3D3",
    //     borderRadius: 6,
    //     display: "flex",
    //     flexDirection: "column",
    //     justifyContent: "center",
    //     alignItems: "space-between",
    //     gap: "10px",
    //   }}
    // >
    //   <List>
    //     <ListItem>
    //       <ListItemText primary="Wastage" style={styles.textStyle} />
    //       {isLoading ? (
    //         <CircularProgress size={24} sx={{ color: "#B88A35" }} />
    //       ) : (
    //         <Switch
    //           checked={wastageEnabled === true ? true : false}
    //           onChange={handleWastageToggle}
    //           sx={{
    //             "& .MuiSwitch-track": {
    //               background:
    //                 "linear-gradient(180deg, #E8EAEA 0%, #FFFFFF 100%)", // Light gradient for unchecked state
    //               opacity: 1,
    //             },
    //             "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    //               background:
    //                 "linear-gradient(180deg, #B88A35 0%, #855E2A 100%)", // Golden gradient for checked state
    //               opacity: 1,
    //             },
    //             "& .MuiSwitch-thumb": {
    //               background:
    //                 "linear-gradient(180deg, #FFFFFF 0%, #E8EAEA 100%)", // Light gradient for thumb in unchecked state
    //             },
    //             "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    //               background: "#FFFFFF", // Solid white for thumb when checked
    //             },
    //           }}
    //         />
    //       )}
    //     </ListItem>
    //   </List>

    //   {/* Logout */}
    //   <List onClick={() => setIsLogoutOpen(true)}>
    //     <ListItem>
    //       <ListItemText primary="Logout" style={styles.textStyle} />
    //       <ListItemIcon>
    //         <img
    //           src={Icons.logout_black_icon}
    //           alt="Logout"
    //           style={{ width: 24, height: 24 }}
    //         />
    //       </ListItemIcon>
    //     </ListItem>
    //   </List>

    //   {isLogoutOpen && (
    //     <LogoutModal onClose={handleCloseModal} onLogOut={handleLogOut} />
    //   )}
    // </div>

    <>
      <div className="wastage-logout-container">
        <div className="wastage-container-div">
          <div>
            <p className="wastage-para">Wastage</p>
          </div>
          <div>
            {isLoading ? (
              // <CircularProgress size={24} color="#B88A35" />
              <Spinner />
            ) : (
              <Switch
                checked={wastageEnabled === true ? true : false}
                onChange={handleWastageToggle}
                sx={{
                  "& .MuiSwitch-track": {
                    background:
                      "linear-gradient(180deg, #E8EAEA 0%, #FFFFFF 100%)", // Light gradient for unchecked state
                    opacity: 1,
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    background:
                      "linear-gradient(180deg, #B88A35 0%, #855E2A 100%)", // Golden gradient for checked state
                    opacity: 1,
                  },
                  "& .MuiSwitch-thumb": {
                    background:
                      "linear-gradient(180deg, #FFFFFF 0%, #E8EAEA 100%)", // Light gradient for thumb in unchecked state
                  },
                  "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
                    background: "#FFFFFF", // Solid white for thumb when checked
                  },
                }}
              />
            )}
            {/* <Switch
                checked={wastageEnabled === true ? true : false}
                onChange={handleWastageToggle}
                className="wastage-switch"
              /> */}
          </div>
        </div>
        <div className="logout-container-div">
          <div>
            <p className="wastage-para">Log Out</p>
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => setIsLogoutOpen(true)}
          >
            <img src={Icons.logout_black_icon} alt="" />
          </div>
        </div>
        {isLogoutOpen && (
          <LogoutModal onClose={handleCloseModal} onLogOut={handleLogOut} />
        )}
      </div>
    </>
  );
};

export default SettingComponent;
